/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, } from './Address';
import { GeoLocationFromJSON, GeoLocationToJSON, } from './GeoLocation';
import { ResourceTagFromJSON, ResourceTagToJSON, } from './ResourceTag';
/**
 * Check if a given object implements the LocationRequest interface.
 */
export function instanceOfLocationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function LocationRequestFromJSON(json) {
    return LocationRequestFromJSONTyped(json, false);
}
export function LocationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'geoLocation': !exists(json, 'geoLocation') ? undefined : GeoLocationFromJSON(json['geoLocation']),
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'active': json['active'],
        'nielsenArea': !exists(json, 'nielsenArea') ? undefined : json['nielsenArea']
    };
}
export function LocationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'name': value.name,
        'address': AddressToJSON(value.address),
        'geoLocation': GeoLocationToJSON(value.geoLocation),
        'networkId': value.networkId,
        'active': value.active,
        'nielsenArea': value.nielsenArea
    };
}
